import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Geyser3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.GEYSER3;
}

export default Geyser3PoiTileEntity;
